import React from 'react'
import { Link  } from 'react-router-dom'

export default function Shipping(props) {
  
  return (

    <div  id="contact" style={{marginTop:'5em', textAlign:'left', marginLeft:'0.2em'}}  >
       <h1>Shipping</h1>
       <div>
       I'm based in Bega NSW. Probably best if you can drop in for a chat to see what you need.
       </div>
       <br/>
       <div>
       I ship bows within Australia using Australia Post.
       </div>
       <br/>
       <div>
       Valuable instruments should be insured in transit. 
       I can offer options but it is the customers responsibility to arrange tranport and insurance that meets their needs.
       </div>
       
      
    </div>

  );
}

